import { BreakpointTrackerContext } from '@jutro/layout';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import twiaWizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss'
// import messages from './PaymentPlans.messages';
import metadata from './PaymentPlansTable.metadata.json5';
import messages from './PaymentPlansTable.messages'
import { Button } from '@jutro/legacy/components';

function PaymentPlansTable(props) {
    const {
        bindDataVM,
        writeValue,
        onViewPaymentPlan,
        autoDraft,
        paymentPlans
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useTranslator();
    const [plans, setPlans] = useState();

    // DE17446
    useEffect(()=>{
        const paymentPlansTableData = paymentPlans || bindDataVM.paymentPlans.value

        setPlans(paymentPlansTableData)
    },[bindDataVM, paymentPlans])

    const viewInstallments = useCallback((item) => (
        <Button onClick={() => onViewPaymentPlan(item)}>
            {translator(messages.view)}
        </Button>
    ), [onViewPaymentPlan, translator]);

    const viewTotal= useCallback((item, index) => (
        <CurrencyField
            id={`total${index}`}
            value={item.total}
            readOnly
            hideLabel
        />
    ), []);

    const viewDownPayment= useCallback((item, index) => (
        <CurrencyField
            id={`downPayment${index}`}
            value={item.downPayment}
            readOnly
            hideLabel
        />
    ), []);

    const onSelectionChange = useCallback((value) => {
        const selectedPlan = plans[value].billingId

        writeValue(selectedPlan, 'selectedPaymentPlan');
    }, [plans, writeValue]);

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        planListTable: {
            data: plans,
            selectedRows: [_.findIndex(plans, (plan) => 
                plan.billingId === bindDataVM.selectedPaymentPlan.value)]
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            viewInstallments,
            onSelectionChange,
            viewDownPayment,
            viewTotal
        },
        resolveClassNameMap: twiaWizardStyles
    };

    return (
        <ViewModelForm
                uiProps={metadata.componentContent}
                model={plans}  // DE17446
                overrideProps={overrideProps}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
    )
}

PaymentPlansTable.propTypes = wizardProps;
export default PaymentPlansTable;
